var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/get-claims.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_CLAIMS_MESSAGE_TYPE = "get_claims";
var getClaims = (_0, ..._1) => __async(void 0, [_0, ..._1], function* (userId, limit = 3, order = { type: "last_updated", asc: false }) {
  const info = {
    user_id: userId,
    limit,
    order
  };
  const params = {
    message_type: GET_CLAIMS_MESSAGE_TYPE,
    info
  };
  return SocketAsFetch.fetch(params);
});
export {
  GET_CLAIMS_MESSAGE_TYPE,
  getClaims
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/claims-b2b-api'] = window.leagueSDKsPresent['@leagueplatform/claims-b2b-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/claims-b2b-api'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/claims-b2b-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/claims-b2b-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map